/**
 * Hook to fetch the list of transfers for an organization.
 */
import { useState } from 'react'

import { customFetch } from '../utils/customFetch'
import { Transfer, TransfersListResponse } from '../interfaces/Transfer'

import { makeUrlTransfers } from './connectionData'

const useTransfersFetcher = () => {
  const [errorTransfers, setErrorTransfers] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const fetchTransfers = async (
    organizationId: string,
    status?: string
  ): Promise<{ transfers: Transfer[]; total: number } | null> => {
    setLoading(true)
    try {
      let url = makeUrlTransfers(organizationId)

      if (status) {
        url += `?status=${status}`
      }
      const data = await customFetch<TransfersListResponse>(url)
      setErrorTransfers(null)

      return { transfers: data.transfers, total: data.total }
    } catch (err) {
      const myErr = err instanceof Error ? err : new Error('Error desconocido')
      setErrorTransfers(myErr)

      return null
    } finally {
      setLoading(false)
    }
  }

  return { errorTransfers, loading, fetchTransfers }
}

export default useTransfersFetcher
